import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
	providedIn: 'root'
})
export class CalendarService {
	private startDateSubject = new BehaviorSubject<Date | null>(null)
	private endDateSubject = new BehaviorSubject<Date | null>(null)
	private minDateSubject = new BehaviorSubject<Date>(new Date())

	startDate$ = this.startDateSubject.asObservable()
	endDate$ = this.endDateSubject.asObservable()
	minDate$ = this.minDateSubject.asObservable()

	getStartDate() {
		return this.startDateSubject.value
	}

	getEndDate() {
		return this.endDateSubject.value
	}

	setMinDate(date: Date) {
		this.minDateSubject.next(date)
	}

	setStartDate(date: Date) {
		this.startDateSubject.next(date)
	}

	setEndDate(date: Date | null) {
		this.endDateSubject.next(date)
	}

	resetCalendar() {
		this.startDateSubject.next(null)
		this.endDateSubject.next(null)
		this.minDateSubject.next(new Date())
	}
}
